import { faBell } from "@fortawesome/pro-regular-svg-icons/faBell";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { AccessKeys } from "app/appConstants";
import { getNewMessagesCounter, notificationCounter } from "app/features/notification/notificationSlice";
import { useAppDispatch, useAppSelector } from "app/store";
import { useSession } from "providers/SessionProvider";
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { WorkpsaceNotifications } from "views/foundation/notification/Header/WorkpsaceNotifications";
import { HeaderLinkButton } from "./HeaderLinkButton";

/////////////////////////////////////////////////////////////////////////////////////////////////

export const HeaderNotifications: React.FC = () => {
    const { t } = useTranslation("shared");
    const session = useSession();
    const dispatch = useAppDispatch();
    const [open, setOpen] = useState<boolean>(false);
    const newMessages = useAppSelector(notificationCounter);

    ///
    function handleToggle() {
        setOpen(!open);
    }

    ///
    function handleClose() {
        setOpen(false);
    }

    const getCounter = () => {
        dispatch(getNewMessagesCounter({ userId: session.user.userId }));
    };

    /// Limpa as notificações ao FECHAR.
    React.useEffect(() => {
        getCounter();
        var counterTimer = setInterval(() => getCounter(), 60000);

        return () => {
            clearInterval(counterTimer);
        };
    }, []);

    ///
    return (
        <>
            <HeaderLinkButton
                accessKey={AccessKeys.Notification}
                iconOrUrl={faBell}
                notificationIcon={newMessages != null && (newMessages.regularNotifications > 0 || newMessages.priorityNotifications > 0) ? faCircle : undefined}
                open={open}
                handleClose={handleClose}
                handleToggle={handleToggle}
                tooltip={t("App.Menu.Topbar.Notification.Title")}
            >
                {open && <WorkpsaceNotifications onCloseMenu={handleClose} />}
            </HeaderLinkButton>
        </>
    );
};
